import axios from 'axios';


// 登录请求方法
const loginreq = (method, url, params) => {
    return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/json;charset:utf-8',
            'verificationid':localStorage.getItem('verificationid')
        },
        data: params,
        traditional: true,
    }).then(res => res.data);
};
// 通用公用方法
const req = async (method, url, params) => {
  let res = await axios({
    method: method,
    url: url,
    headers: {
      'Content-Type': 'application/json;charset:utf-8',
      tokenId: localStorage.getItem('logintoken'),
      // tokenId: '71c78bc795e54d659296decb0c4370fc',
    },
    data: params,
    traditional: true,
  });
  return await res.data;
};
//获取图片验证码
const getVerification = (method, url, params) => {
  return axios({
    method: method,
    url: url,
    headers: {
      'Content-Type': 'application/json;charset:utf-8',
    },
    data: params,
    traditional: true,
    responseType: 'blob',
  }).then(res => res.data);
};
//导出
const exportExcel = (method, url, params) => {
  return axios({
    method: method,
    url: url,
    headers: {
      'Content-Type': 'application/json;charset:utf-8',
      tokenId: localStorage.getItem('logintoken'),
      // tokenId: '09f76db120c14d6d868e2ba2082edad9'
    },
    data: params,
    traditional: true,
    responseType: 'blob',
  }).then(res => res.data);
};

export {
    loginreq,
    req,
    getVerification,
    exportExcel
}



// WEBPACK FOOTER //
// ./src/api/axiosFun.js